import { htmlFontSize } from "./base"

export const blocks = {
  ":root": {
    letterSpacing: "initial !important",
    lineHeight: "2.2rem !important",
    fontSize: htmlFontSize,
  },

  body: {
    backgroundColor: "#f6f6f6",
    lineHeight: "2.2rem !important",
  },
}
